var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('avatar',_vm._b({class:_vm.nudgeLeft,attrs:{"color":"grey lighten-3","small":_vm.small,"on":on}},'avatar',attrs,false),[_vm._v(" +"+_vm._s(_vm.count)+" ")])]}}])},_vm._l((_vm.researchers),function(researcher){return _c('div',{key:researcher.id},[_vm._v(" "+_vm._s(researcher.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }